import type { SVGProps } from "react";
export function Spotify(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        d="m7.99992 1.33337c-3.66667 0-6.66667 3-6.66667 6.66667 0 3.66666 3 6.66666 6.66667 6.66666 3.66668 0 6.66668-3 6.66668-6.66666 0-3.66667-2.9667-6.66667-6.66668-6.66667zm2.49998 9.76663c-1.56665-.9666-3.53332-1.16663-5.86665-.6333-.23333.0667-.43333-.1-.5-.3-.06666-.23333.1-.43333.3-.49999 2.53334-.56667 4.73333-.33334 6.46665.73329.2334.1.2667.3667.1667.5667-.1333.2-.3667.2667-.5667.1333zm.6667-1.79996c-1.80002-1.1-4.53335-1.43333-6.63335-.76667-.26666.06667-.56666-.06666-.63333-.33333s.06667-.56667.33333-.63333c2.43333-.73334 5.43333-.36667 7.50005.9.2.1.3.43333.1333.66666-.1667.23334-.4667.33334-.7.16667zm-6.96668-2.8c-.33333.1-.66667-.1-.76667-.4-.1-.33333.1-.66667.4-.76667 2.36667-.7 6.26665-.56666 8.73335.9.3.16667.4.56667.2333.86667-.1666.23333-.5666.33333-.8666.16667-2.13338-1.26667-5.70005-1.4-7.73338-.76667z"
        fill="currentColor"
      />
    </svg>
  );
}
